/**
* @file 资源管理-安全检查详情
* */
<template>
  <div id="securityInspectorDetail">
    <!-- 合格证打印内容 -->
    <div id="print" v-if="printContent.organizationName">
      <div style="display: inline-block;padding: 2rem 5px;font-size:9px">
        <div style="margin-bottom: 5px;text-align: center;">{{ printContent.organizationName }}</div>
        <div style="margin-bottom: 20px;text-align: center;">营运客车例检合格证</div>

        <div style="margin-bottom: 20px;padding: 8px 10px;border: 1px black solid;line-height: 2rem;">
          <div>编号：{{ printContent.number }} </div>
          <div>检查时间：{{ printContent.created | filterTime('YYYY.MM.DD HH:mm') }}</div>
          <div>车辆号牌：{{ printContent.licenseNo }}</div>
          <div>安全检查员：{{ printContent.inspectorName }}</div>
          <div>
            检查结果：
            <span
              :style="{ fontSize: printContent.result == 1 ? '' : '17px', fontWeight: printContent.result == 1 ? '' : 'bold' }">
              {{ printContent.result == 1 ? '通过' : '不通过' }}
            </span>
          </div>
          <div>安全例检合格证：（盖章）</div>
        </div>

        <div>注：本通知单随车携带，24小时内报班有效！</div>
      </div>
    </div>

    <div class="flex" style="justify-content: space-between;">
      <h2>营运客车安全例行检查</h2>
      <el-button type="primary" @click="print">打印例检合格证</el-button>
    </div>

    <div class="info">

      <div>
        <span>机构名称</span>
        <span>{{ info.organizationName }}</span>
      </div>

      <div>
        <span>车辆号牌</span>
        <span v-if="info.licenseNo" :style="getPlateStyle(info.licenseNo)">{{ formatPlateNumber(info.licenseNo) }}</span>
        <span v-else>-</span>
      </div>

      <div>
        <span>车辆编号</span>
        <span>{{ info.vehicleNo }}</span>
      </div>

      <div>
        <span>座位数</span>
        <span>{{ info.vehicleSeat }}</span>
      </div>

      <div>
        <span>车型</span>
        <span>{{ info.vehicleModel }}</span>
      </div>

      <div>
        <span>检查编号</span>
        <span>{{ info.number }}</span>
      </div>

      <div>
        <span>安检机构</span>
        <span>{{ info.inspectorOrganizationName }}</span>
      </div>

      <div>
        <span>安检员</span>
        <span>{{ info.inspectorName }}</span>
      </div>

      <div>
        <span>安检结果</span>
        <span :style="{ color: info.result == 1 ? '#009900' : '#FF0000' }">
          {{ info.result == 1 ? '通过' : '不通过' }}
        </span>
      </div>

    </div>

    <el-table :data="info.templateList" height="calc(100% - 116px)" border>
      <el-table-column type="index" label="序号" width="100"></el-table-column>
      <el-table-column prop="templateName" label="项目名称" width="200"></el-table-column>
      <el-table-column prop="templateContent" label="检查内容" width="200"></el-table-column>
      <el-table-column prop="remark" label="备注" v-slot="{ row }">
        <span> {{ row.remark || '-' }}</span>
      </el-table-column>
      <el-table-column prop="photoDetail" label="图片" v-slot="{ row }">
        <template v-if="row.photoDetail[0]">
          <el-image class="tableimg" v-for="(item, index) in row.photoDetail" :key="index" :src="row.photoDetail[index]"
            :preview-src-list="row.photoDetail">
          </el-image>
        </template>
        <span v-else>-</span>
        <!-- <img v-for="(item, index) in row.photoDetail.split(',')" :key="index" :src="mixinQiniuImg(item)" /> -->
      </el-table-column>
      <el-table-column prop="result" label="检查结果" width="100" v-slot="{ row }">
        <span :style="{ color: row.result == 1 ? '#009900' : '#FF0000' }">
          {{ row.result == 1 ? '合格' : '不合格' }}
        </span>
      </el-table-column>
      <el-table-column prop="inspectorName" label="安检员" width="100"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "securityInspectorDetail",
  data() {
    return {
      info: {},
      printContent: {}
    };
  },
  created() {
    this.getInfo(this.$route.query.id)
  },
  methods: {
    async getInfo(id) {
      let url = "/api/v1/manage/inspect/detail/" + id;
      let res = await this.$axios.get(url);
      if (res && res.code == 1) {
        res.data.templateList.map(item => {
          item.photoDetail = item.photoDetail.split(',').map(path => {
            if (path) {
              return this.mixinQiniuImg(path)
            } else {
              return null
            }
          })
        })
        this.info = res.data;
      }
    },

    /* 打印合格证 */
    print() {
      this.printContent = {
        organizationName: this.info.organizationName,
        number: this.info.number,
        created: this.info.created,
        licenseNo: this.info.licenseNo,
        inspectorName: this.info.inspectorName,
        result: this.info.result
      }

      this.$nextTick(() => {
        const printContentHtml = document.getElementById("print").innerHTML;
        const iframe = document.createElement("iframe");
        document.body.appendChild(iframe);
        iframe.contentDocument.write(printContentHtml);
        iframe.contentDocument.close();
        iframe.contentWindow.print();
      })
    },
  }
};
</script>

<style lang="less">
#securityInspectorDetail {
  .info {
    margin: 20px 0;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-row-gap: 20px;

    div {
      span {
        display: inline-block;

        &:nth-child(1) {
          color: #666;
          width: 80px;
        }
      }
    }
  }

  .tableimg {
    width: 50px;
    height: 50px;
    margin-right: 10px;
    border-radius: 5px;
  }
}

iframe,
#print {
  width: 0;
  height: 0;
  position: absolute;
  left: -500px;
  top: -500px;
}
</style>
